import React from 'react';
import Modal from 'components/layout/modal';
import events from 'lib/events';
import moment from 'moment';
import dealerApi from 'api/dealer';
import Container from './Integrations/container';
import session from 'services/sessionService';
import ConfirmationModal from './Integrations/confirmationModal';
import UserAccessManagerModal from './Integrations/userAccessManager';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import Link from 'components/layout/link';

let EvosusTitle;
let RBControlTitle = 'RB Retail & Service Solutions';

const vendorIDs = {
  none: 0,
  rb: 1,
  evosus: 2,
};

class Integrations extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    apiKey: null,
    dealer: null,
    isKeyActive: false,
    infoModalContent: null,
    confirmModalAction: null,
    infoModal: 'hide-component',
    confirmationModalContent: null,
  };

  componentWillMount() {
    EvosusTitle = this.props.intl.formatMessage({id: 'general.evosus'});
    RBControlTitle = this.props.intl.formatMessage({id: 'general.retail.service.solutions'});
    Promise.all([
      dealerApi.getDealer(session.getUser().dealerId),
    ]).then(([dealer]) => {
      this.setState({
        dealer: dealer,
      });
      if (this.state.dealer && this.state.dealer.CurrentPOSIntegration) {
        this.getAPIKey(dealer.id, this.state.dealer.CurrentPOSIntegration);
      }
    });
  }

  getAPIKey = (id, vendorID = vendorIDs.rb) => {
    return dealerApi.getAPIKey(id, new Date().toISOString(), vendorID).then((results) => {
      this.setState({
        apiKey: results,
      });
    });
  };

  setEvosusConfirmationContent = () => {
    if (this.setMessage(vendorIDs.evosus, EvosusTitle)) {
      this.confirmModalAction = this.manageEvosusControls;
    } else {
      this.confirmModalAction = this.close;
    }
    events.publish('integrations-confirmation-modal');
  };

  setMessage = (vendor, title) => {
    if (vendor === this.state.dealer.CurrentPOSIntegration && [vendorIDs.rb, vendorIDs.evosus].includes(vendor)) {
      this.setState({
        confirmationModalContent: <div>
          <h2><FormattedMessage id='general.confirmation'/></h2>
          <p className='info-modal-description'>
            <span className='modal-warning'>
              <i className='bl bl-attention'/>
              <FormattedMessage id='integrations.about.deactivate' values={{company: title}} />
            </span>
            <br/>
            <br/>
            <FormattedMessage id='integrations.click.confirm' values={{company: title}}/>
            <br/>
            &ensp;&ensp;- <FormattedMessage id='integrations.deactivation.time'/>;<br/>
            &ensp;&ensp;- <FormattedMessage id='integrations.purchase.removed'/>;<br/>
            &ensp;&ensp;- <FormattedMessage id='integrations.active.pos.again'/>.<br/>
            &ensp;&ensp;- <FormattedMessage id='integrations.pos.desactivation.process'/>.<br/>
          </p>
        </div>,
      });

      return true;
    }

    if (vendor && this.state.dealer.CurrentPOSIntegration && vendor !== this.state.dealer.CurrentPOSIntegration) {
      this.setState({
        confirmationModalContent: <div>
          <h2><FormattedMessage id='integrations.invalid.integration'/></h2>
          <p className='info-modal-description'>
            <span className='modal-warning'>
              <FormattedMessage id='integrations.deactivate.current.integration'/>
            </span><br/>
          </p>
        </div>,
      });

      return false;
    }

    this.setState({
      confirmationModalContent: <div>
        <h2><FormattedMessage id='integration.activating' values={{company: title}}/> | <FormattedMessage id='general.next.steps'/></h2>
        <p className='info-modal-description'>Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          Fugit assumenda, nesciunt laboriosam et illo dolor quas laborum obcaecati a quaerat, aperiam
          porro, quidem soluta blanditiis at. In reiciendis assumenda fugit?</p>
      </div>,
    });

    return true;
  };

  setRBConfirmationContent = () => {
    if (this.setMessage(vendorIDs.rb, RBControlTitle)) {
      this.confirmModalAction = this.manageRBControls;
    } else {
      this.confirmModalAction = this.close;
    }
    events.publish('integrations-confirmation-modal');
  };

  changeDealerIntegration = (value) => {
    const dealer = this.state.dealer;

    dealer.CurrentPOSIntegration = value;
    dealer.CurrentPOSIntegrationTime = moment();
    if (value === vendorIDs.none) {
      dealer.CurrentPOSIntegrationTime = null;
    }
    dealerApi.saveDealer(dealer)
      .then(d => {
        this.setState({
          dealer: d,
        });
        if (dealer.CurrentPOSIntegration === vendorIDs.rb) {
          this.getAPIKey(d.id, vendorIDs.rb);
        } else if (dealer.CurrentPOSIntegration === vendorIDs.evosus) {
          this.getAPIKey(d.id, vendorIDs.evosus);
        }
      });
  };

  close = () => {
    this.setState({
      infoModal: 'hide-component',
    });
  };

  isActive = (vendor) => {
    return !(this.state.dealer === null || this.state.dealer.CurrentPOSIntegration !== vendor);
  };

  manageEvosusControls = () => {
    this.changeDealerIntegration(this.state.dealer.CurrentPOSIntegration !== vendorIDs.evosus ? vendorIDs.evosus : vendorIDs.none);
  };

  manageRBControls = () => {
    this.changeDealerIntegration(this.state.dealer.CurrentPOSIntegration !== vendorIDs.rb ? vendorIDs.rb : vendorIDs.none);
  };

  openUserAccessManagerModal = () => {
    events.publish('user-access-manager');
  };

  render() {
    let {formatMessage, formatHTMLMessage} = this.props.intl;

    const RBSteps = [formatMessage({id: 'integrations.rb.step.one'}),
      formatMessage({id: 'integrations.rb.step.two'}),
      formatMessage({id: 'integrations.rb.step.three'})];

    const EvoSteps = [formatMessage({id: 'integrations.evosus.step.one'}),
      formatMessage({id: 'integrations.evosus.step.two'}),
      formatMessage({id: 'integrations.evosus.step.three'})];

    return (
      <div id='page-integrations'>
        <h2 className='with-keyline'><FormattedMessage id='integrations.point.sale.system'/>
          <Link label='integrations.manage.user.access' action={this.openUserAccessManagerModal} underline={true}/></h2>
        <p><FormattedHTMLMessage id='integrations.integrate.instance.alex'/></p>
        <div className='container'>

          <Container title={RBControlTitle}
                     description={formatHTMLMessage({id: 'integrations.rb.container.description'})}
                     isActive={this.isActive(vendorIDs.rb)}
                     showApiKeyContainer={true}
                     lastPOSActivity={this.state.dealer !== null ? this.state.dealer.LastPOSActivity : null}
                     apiKey={this.state.apiKey}
                     steps={RBSteps}
                     openModalConfirm={this.setRBConfirmationContent}
                     activationEnabled={true}/>

          <Container title={EvosusTitle}
                     description={formatHTMLMessage({id: 'integrations.evosus.container.description'})}
                     isActive={this.isActive(vendorIDs.evosus)}
                     showApiKeyContainer={true}
                     lastPOSActivity={this.state.dealer !== null ? this.state.dealer.LastPOSActivity : null}
                     apiKey={this.state.apiKey}
                     steps={EvoSteps}
                     openModalConfirm={this.setEvosusConfirmationContent}
                     activationEnabled={false}/>
          {/* ALEX-2579 Disable action for evosus */}


          <ConfirmationModal content={this.state.confirmationModalContent}
                             onConfirm={this.confirmModalAction}/>

          <div className={this.state.infoModal + ' integrations-info-modal'}>
            <Modal onClose={this.close}
                   width={700}>
              {this.state.infoModalContent}
            </Modal>
          </div>
        </div>
        <UserAccessManagerModal/>
      </div>
    );
  }
}

export default injectIntl(Integrations);
